module.exports = __webpack_public_path__ + "static/cover_aboutpage-823b36da1ac569bbccd0e6316cac1b05.gif";